import { useState, useRef, useEffect, useCallback } from 'react';
import { TOAST_DURATIONS } from '../constants/reactionScheme';

export function useToast() {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const show = useCallback((message: string, duration?: number) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setToastMessage(message);
    setShowToast(true);
    timeoutRef.current = setTimeout(() => setShowToast(false), duration ?? TOAST_DURATIONS.DEFAULT);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return { showToast, toastMessage, show };
}
